import { useAppSelector } from '../../../redux/hooks.js';
import { NO_VALUE } from '../../constants.js';
import { FORM_TYPES } from '../../../inlineForms.js';
import { activeViewSelector, twoStepTrackingComponentStateSelector, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
export const useLinkedinComponentStateBuilder = () => {
    const componentStateForTwoStep = useAppSelector(twoStepTrackingComponentStateSelector);
    const activeView = useAppSelector(activeViewSelector);
    if (activeView === FORM_TYPES.LINKEDIN_IMPORT_PROFILE) {
        return NO_VALUE;
    }
    return componentStateForTwoStep;
};
//# sourceMappingURL=useLinkedinComponentStateBuilder.js.map